/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Complete_Signin_WaitingInputs */



/**
* | output |
* | --- |
* | "This window will update automatically once you've signed in." |
*
* @param {Login_Complete_Signin_WaitingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_complete_signin_waiting = /** @type {((inputs?: Login_Complete_Signin_WaitingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Complete_Signin_WaitingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette fenêtre se mettra à jour automatiquement une fois connecté.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Fenster wird sich nach der Anmeldung automatisch aktualisieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa finestra si aggiornerà automaticamente una volta effettuato l'accesso.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это окно обновится автоматически после входа в систему.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta ventana se actualizará automáticamente una vez que haya iniciado sesión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("登录后，此窗口将自动更新。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サインインすると、このウィンドウは自動的に更新されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉग इन करने के बाद यह विंडो अपने आप अपडेट हो जाएगी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esta janela será atualizada automaticamente assim que você fizer login.")
	return /** @type {LocalizedString} */ ("This window will update automatically once you've signed in.")
});